import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function verifyEmailOtpData(payload) {
  try {
    const url = paths.verifyEmailOtp();
    const response = await axiosInstance.post(url, payload);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useVerifyEmailOtp = () => {
  return useMutation({
    mutationFn: verifyEmailOtpData,
  });
};

export { useVerifyEmailOtp };
